import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzK9 } from './pages'

type TIdToPageMapWoofzK9 = Record<PageIdWoofzK9, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_K9: TIdToPageMapWoofzK9 = {
  [PageIdWoofzK9.DOG_AGE_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/DogAge').then((m) => ({
        default: m.DogAge,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/questions/DogAge'),
  },
  [PageIdWoofzK9.DOG_SEX_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/SexQuestion').then(
        (m) => ({
          default: m.SexQuestion,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/questions/SexQuestion'),
  },
  [PageIdWoofzK9.DOG_BREED_K9]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzK9.DOG_BREED_ID_K9]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9/pages/questions/dog-breed/breed-id/BreedPhotoScreenK9'
      ).then((m) => ({
        default: m.BreedPhotoScreenK9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9/pages/questions/dog-breed/breed-id/BreedPhotoScreenK9'
      ),
  },
  [PageIdWoofzK9.URGE_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/urge/UrgePage'),
  },
  [PageIdWoofzK9.CHALLENGES_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/GoalsQuestionK9').then(
        (m) => ({
          default: m.GoalsQuestionK9,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/GoalsQuestionK9'),
  },
  [PageIdWoofzK9.URGE_1_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/urge/Urge1Page').then((m) => ({
        default: m.Urge1Page,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/urge/Urge1Page'),
  },
  [PageIdWoofzK9.LEASH_PULLING_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/LeashPulling').then(
        (m) => ({
          default: m.LeashPulling,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/LeashPulling'),
  },
  [PageIdWoofzK9.URGE_LEASH_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/urge/UrgeLeashPage').then((m) => ({
        default: m.UrgeLeashPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/urge/UrgeLeashPage'),
  },
  [PageIdWoofzK9.DURING_WALK_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/DuringWalkQuestion').then(
        (m) => ({
          default: m.DuringWalkQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/DuringWalkQuestion'),
  },
  [PageIdWoofzK9.URGE_NOT_ALONE_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/urge/UrgeNotAlone').then((m) => ({
        default: m.UrgeNotAlonePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/urge/UrgeNotAlone'),
  },
  [PageIdWoofzK9.AGRESSIVE_BEHAVIOR_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/AgressiveBehavior').then(
        (m) => ({
          default: m.AgressiveBehavior,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/AgressiveBehavior'),
  },
  [PageIdWoofzK9.TRIGGERS_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/TriggersQuestion').then(
        (m) => ({
          default: m.TriggersQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/TriggersQuestion'),
  },
  [PageIdWoofzK9.URGE_2_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzK9.BEHAVIOR_ISSUES_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/BehaviorIssues').then(
        (m) => ({
          default: m.BehaviorIssues,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/BehaviorIssues'),
  },
  [PageIdWoofzK9.DOG_ACT_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/DogActQuestion').then(
        (m) => ({
          default: m.DogActQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/DogActQuestion'),
  },
  [PageIdWoofzK9.DOG_OFF_AT_HOME_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/DogOffAtHome').then(
        (m) => ({
          default: m.DogOffAtHome,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/DogOffAtHome'),
  },
  [PageIdWoofzK9.REWARDS_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/RewardsQuestion').then(
        (m) => ({
          default: m.RewardsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/RewardsQuestion'),
  },
  [PageIdWoofzK9.IGNORE_COMMANDS_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/DogIgnoreQuestion').then(
        (m) => ({
          default: m.DogIgnoreQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/DogIgnoreQuestion'),
  },
  [PageIdWoofzK9.COMMANDS_61_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/Commands61Question').then(
        (m) => ({
          default: m.Commands61Question,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/Commands61Question'),
  },
  [PageIdWoofzK9.COMMANDS_62_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/Commands62Question').then(
        (m) => ({
          default: m.Commands62Question,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/Commands62Question'),
  },
  [PageIdWoofzK9.COMMANDS_63_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/Commands63Question').then(
        (m) => ({
          default: m.Commands63Question,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/Commands63Question'),
  },
  [PageIdWoofzK9.URGE_3_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/urge/UrgeProgram').then((m) => ({
        default: m.UrgeProgram,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/urge/UrgeProgram'),
  },
  [PageIdWoofzK9.PREPARE_SCREEN_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/urge/UrgePrepareScreen').then(
        (m) => ({
          default: m.UrgePrepareScreen,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/urge/UrgePrepareScreen'),
  },
  [PageIdWoofzK9.DOG_PROFILE_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/dog-profile/DogProfile').then(
        (m) => ({
          default: m.DogProfile,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/dog-profile/DogProfile'),
  },
  [PageIdWoofzK9.URGE_REVIEWED_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/urge/UrgeReviewed').then((m) => ({
        default: m.UrgeReviewedPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/urge/UrgeReviewed'),
  },
  [PageIdWoofzK9.SOCIAL_SCREEN_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/abtest/SocialScreen').then((m) => ({
        default: m.SocialScreenPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/abtest/SocialScreen'),
  },
  [PageIdWoofzK9.PREPARE_FLOW_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/prepare-flow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/prepare-flow/PrepareFlow'),
  },
  [PageIdWoofzK9.EMAIL_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/email/Email'),
  },
  [PageIdWoofzK9.NEWSLETTER_URGE_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/email/NewsletterUrge').then((m) => ({
        default: m.NewsletterUrge,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzK9.DISCIPLINE_SCREEN_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/abtest/DisciplineScreen').then(
        (m) => ({
          default: m.DisciplineScreenPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/abtest/DisciplineScreen'),
  },
  [PageIdWoofzK9.SCRATCH_SCREEN_K9]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9/pages/last-chance-offer/LastChanceOfferScratch'
      ).then((m) => ({
        default: m.LastChanceOfferScratch,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9/pages/last-chance-offer/LastChanceOfferScratch'
      ),
  },
  [PageIdWoofzK9.WELCOME_TO_WOOFZ_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/questions/WelcomeToWoofz').then(
        (m) => ({
          default: m.WelcomeToWoofz,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/questions/WelcomeToWoofz'),
  },
  [PageIdWoofzK9.SUBSCRIPTIONS_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/subscriptions/Subscriptions').then(
        (m) => ({
          default: m.Subscriptions,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzK9.CHAT_UPSELL_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/upsell/ChatUpsellComponent').then(
        (m) => ({
          default: m.ChatUpsellComponent,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/upsell/ChatUpsellComponent'),
  },
  [PageIdWoofzK9.UPSELL_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/pages/upsell/Upsell'),
  },
  [PageIdWoofzK9.UPSELL_FEEDING_GUIDE_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzK9.UPSELL_EMOTIONAL_SUPPORT_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/upsell/EmotionalSupportUpsell').then(
        (m) => ({
          default: m.EmotionalSupportUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzK9.DOWNLOAD_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzK9.ACCOUNT_K9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9/modules/account/AccountK9').then((m) => ({
        default: m.AccountK9,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9/modules/account/AccountK9'),
  },
}
